import { MenuSideProps } from "@/Components/MenuSide";
import { LoginResponse } from "@/interfaces/IAuth";
import { IUser } from "@/interfaces/IUser";
import serverInstance from "@/utils/axios";
import axiosBaseQuery from "@/utils/axiosBaseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { AxiosError } from "axios";

/**
 * IMPORTANTE:
 * Debido a una limitación actual, no se pueden exportar los hooks individualmente sin causar problemas de tipos.
 * El siguiente código es un intento de exportar el hook useLoginMutation, pero resulta en el siguiente error de TypeScript:
 * "El tipo inferido de 'useLoginMutation' no se puede nombrar sin una referencia a '../../../node_modules/@reduxjs/toolkit/dist/query/react/buildHooks'. Es probable que esto no sea portátil. Es necesaria una anotación de tipo.ts(2742)"
 * en su lugar llamar directamente a authService y acceder al hook
 * @example
   authService.useLoginMutation(...params)
 */

// const { useLoginMutation } = authService;
// export { useLoginMutation }; // Esta exportación causa un error de TypeScript
export const authService = createApi({
  reducerPath: "authApi",
  baseQuery: axiosBaseQuery,
  tagTypes: ["myProfileQuery"],
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, { email: string; password: string }>({
      queryFn: async ({ email, password }) => {
        try {
          const result = await serverInstance({
            url: "/auth/login/",
            method: "POST",
            data: { email, password },
          });
          return { data: result.data as LoginResponse };
        } catch (axiosError) {
          const err = axiosError as AxiosError;
          return {
            error: {
              status: err.response?.status,
              data: err.response?.data || err.message,
            },
          };
        }
      },
    }),
    logout: builder.mutation<{ message: string }, { refresh: string }>({
      query: ({ refresh }) => ({
        url: "/auth/logout/",
        method: "POST",
        data: {
          refresh_token: refresh,
        },
      }),
    }),
    myProfile: builder.query<IUser, void>({
      query: () => ({
        url: "/users/profile",
        method: "GET",
      }),
      providesTags: ["myProfileQuery"],
    }),
    findById: builder.query<IUser, { user?: number }>({
      query: ({ user }) => ({
        url: `/users/${user}`,
        method: "GET",
        // params: {
        //   user: user,
        // },
      }),
    }),
    menusByGrups: builder.query<MenuSideProps[], { groups: number[] }>({
      query: ({ groups }) => ({
        // url: `/sign/menus/group`,
        url: `/users/menus/by-groups`,
        method: "POST",
        data: {
          groups: groups.join(","),
        },
      }),
    }),
  }),
});
